import styled from 'styled-components';
import VehicleInfo from './component';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';

export const DetailCell = styled.div`
  position: relative;
  flex: 1;
  max-width: ${(props) => `${props.width}px`};
  margin-right: ${(props) => props.theme.base.gridSizes.XS};
  white-space: nowrap;
  display: flex;
  flex-direction: column;

  ${(props) => (props.align === 'center' || !props.align ? 'align-items: center;' : '')}
  ${(props) => (props.align === 'left' ? 'align-items: flex-start;' : '')}
  ${(props) => (props.align === 'right' ? 'align-items: flex-end;' : '')}

  ${(props) => (props.small ? 'font-size: 12px;' : '')}
`;

export const IconContainer = styled.span`
  position: relative;
`;

export const HeightIcon = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -8px;
  width: 1px;
  background-color: var(--greyWolf);
  display: block;

  &:before,
  &:after {
    content: '';
    width: 5px;
    height: 1px;
    display: block;
    background-color: var(--greyWolf);
    left: -2px;
    position: absolute;
  }

  &:before {
    top: 0;
  }

  &:after {
    bottom: 0;
  }
`;

export const WidthIcon = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -4px;
  height: 1px;
  background-color: var(--greyWolf);
  display: block;

  &:before,
  &:after {
    content: '';
    width: 1px;
    height: 5px;
    display: block;
    background-color: var(--greyWolf);
    top: -2px;
    position: absolute;
  }

  &:before {
    left: 0;
  }

  &:after {
    right: 0;
  }
`;

export const ExtraIcon = styled(Icon)`
  color: var(--greyWolf);
  font-size: 20px;
`;

export default styled(VehicleInfo)`
  padding: 8px 0;
  border-bottom: 1px solid var(--greyMouse);

  .monospace {
    font-family: 'Source Code Pro';
  }
`;
